export class Compare {

    static compareStrings(sA, sB, asc = true) {
        const before = sA < sB; // "A" alfabéticamente es menor (va antes)
        const after = sA > sB; // "A" alfabéticamente es mayor (va después)
        if ( before ) return asc ? -1 : 1; // Ascendente (de a a z) o descendente (de la z a la a)
        if ( after ) return asc ? 1 : -1;
        return 0; // Son coincidentes y da igual el orden
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/compare/Compare.js